import { tokens } from '../../tokens/underlyingTokens';
import type { VToken } from '../../types';

export const opBnbTestnet: VToken[] = [
  {
    chainId: 5611,
    address: '0x86F82bca79774fc04859966917D2291A68b870A9',
    decimals: 8,
    symbol: 'vBTCB_Core',
    underlyingToken: tokens[5611][5],
  },
  {
    chainId: 5611,
    address: '0x034Cc5097379B13d3Ed5F6c85c8FAf20F48aE480',
    decimals: 8,
    symbol: 'vETH_Core',
    underlyingToken: tokens[5611][2],
  },
  {
    chainId: 5611,
    address: '0xe3923805f6E117E51f5387421240a86EF1570abC',
    decimals: 8,
    symbol: 'vUSDT_Core',
    underlyingToken: tokens[5611][3],
  },
  {
    chainId: 5611,
    address: '0xD36a31AcD3d901AeD998da6E24e848798378474e',
    decimals: 8,
    symbol: 'vWBNB_Core',
    underlyingToken: tokens[5611][4],
  },
];
